<template>
  <div class="back">
    网络监测中
  </div>
</template>

<script>
export default {
  name: "loading_desktop"
}
</script>

<style scoped>
.back{
  width: 100vw;
  height: 100vh;
}
</style>
